import axios from "axios";
import cookie from "js-cookie";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import SliderArray from "./SliderArray";
import Loader from "../../components/shared/Loader";

export default function SeoData() {
	const [loading, setLoading] = useState(false);
	const history = useHistory();

	const { handleSubmit } = useForm();
	const [sliders, setSliders] = useState([]);

	useEffect(() => {
		axios
			.get(`${process.env.REACT_APP_API_URL}/pages/seo-data/sections/seo-data`)
			.then(response => {
				setSliders(
					response.data?.data?.section?.content?.items?.map((item, index) => ({
						...item,
						id: index,
					})) || []
				);
			});
	}, []);

	const onSubmit = data => {
		const sectionData = {
			section: {
				title: "seo-data",
				content: {
					items: sliders,
				},
			},
		};

		data.content = { items: sliders };

		if (!sectionData) {
			toast.error("برجاء كتابة محتوى");
		} else {
			setLoading(true);
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/pages/seo-data/sections/seo-data`,
					sectionData,

					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (response) {
					history.push("/seoData");
					toast.success("تم التعديل بنجاح!");
					setLoading(false);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
	};

	if (loading) return <Loader />;

	return (
		<>
			<div className="acc-form">
				<div className="card">
					<div className="card-head">
						<h4>بيانات السيو</h4>
					</div>
					<div className="card-body">
						<form onSubmit={handleSubmit(onSubmit)}>
							<Col>
								<Row>
									<Col lg={12}>
										<SliderArray sliders={sliders} setSliders={setSliders} />
									</Col>
								</Row>

								<button className="btn btn-blue">حفظ</button>
								{/* <SaveChangesButton /> */}
							</Col>
						</form>
					</div>
				</div>
			</div>
		</>
	);
}
